import type { IdMeAuthorizationResult } from '../../idme.types';
import type { IdMeVerificationEvent } from './events';
import type { IdMeVerificationContext, VerificationResult } from './types';
import type { GuardArgs } from 'xstate/guards';

// ─────────────────────────────────────────────────────────────────────────────

export const checkIfAnyGroupActive: Guard = ({ context }) => {
  return context.verifiedGroups.length > 0;
};

export const checkIfRequestPrepared: Guard = ({ context }) => {
  return context.request !== undefined;
};

export const checkIfAuthorized: Guard<AuthorizationResultParams> = ({ context }, params) => {
  return context.request !== undefined && params.result.status === 'authorized';
};

export const checkIfAuthorizationCancelled: Guard<AuthorizationResultParams> = (_args, params) => {
  return params.result.status === 'cancelled';
};

export const checkIfVerified: Guard<VerificationResultParams> = (_args, params) => {
  return params.verificationResult.__typename === 'VerifyGroupSuccess';
};

export const checkIfNotVerified: Guard<VerificationResultParams> = (_args, params) => {
  return params.verificationResult.__typename === 'CommunityVerificationNotVerified';
};

export const checkIfLinkedToAnotherIdentity: Guard<VerificationResultParams> = (_args, params) => {
  return params.verificationResult.__typename === 'CustomerLinkedToDifferentCommunityIdentity';
};

export const checkIfIdMeSessionActive: Guard = ({ context }) => {
  return context.hasIdMeSession;
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Guard<GuardParams extends Record<string, unknown> | void = void> = (
  args: GuardArgs<IdMeVerificationContext, IdMeVerificationEvent>,
  params: GuardParams,
) => boolean;

type AuthorizationResultParams = {
  result: IdMeAuthorizationResult;
};

type VerificationResultParams = {
  verificationResult: VerificationResult;
};
